export default __webpack_public_path__ + "static/media/down.017f463d.jpg";